<template>
  <tg-layout>
    <template slot="header">
      <portal to="tools" :disabled="!isMobile">
        <tg-search-tool :data="searchData" @on-submit="handleSearch">
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
          <tg-date-search
            v-if="!isUnReview"
            size="small"
            v-model="dateRange"
          ></tg-date-search>
          <tg-dropdown
            :items="actions"
            trigger="click"
            @on-change="handleChangeStatus"
          ></tg-dropdown>
        </tg-search-tool>
      </portal>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template slot="action" slot-scope="props" v-if="showActionBar">
        <button
          v-if="parseInt(props.row['status']) === 0"
          class="operating_btn agree"
          @click="review(props.row, 'pass')"
        >
          {{ $t("page.tg_business.announcement.action.pass") }}
        </button>
        <button
          v-if="parseInt(props.row['status']) === 0"
          class="operating_btn veto"
          @click="review(props.row, 'veto')"
        >
          {{ $t("page.tg_business.announcement.action.veto") }}
        </button>
        <button
          v-if="
            parseInt(props.row['status']) === 2 ||
              parseInt(props.row['status']) === 3
          "
          class="operating_btn agree"
          @click="review(props.row, 'up')"
        >
          {{ $t("page.tg_business.announcement.action.up") }}
        </button>
        <button
          v-if="parseInt(props.row['status']) === 1"
          class="operating_btn veto"
          @click="review(props.row, 'down')"
        >
          {{ $t("page.tg_business.announcement.action.down") }}
        </button>
      </template>
    </tg-table>
    <tg-announce-review-dialog
      :visible.sync="showReviewDialog"
      :item="reviewItem"
      @on-success="handleReviewSuccess"
    ></tg-announce-review-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/tool/TgDateSearch";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgTable from "@/components/table/TgTable";
import TgAnnounceReviewDialog from "@/components/dialog/TgAnnounceReviewDialog";
import apis from "@/apis";
import authorize from "@/utils/authorize";
const api = apis.tg_business.announcement;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgDropdown,
    TgTable,
    TgAnnounceReviewDialog,
  },
  data() {
    return {
      columns: [],
      reviewColumns: [],
      reviewedColumns: [],
      downColumns: [],
      proxy: api.getData,
      showReviewDialog: false,
      reviewItem: {},
      searchData: {
        targetName: "",
        startDate: "",
        endDate: "",
        status: 0,
      },
      statusItem: null,
      dateRange: {},
    };
  },
  computed: {
    showActionBar() {
      return authorize.pass(this.$store.state.app.user, [
        "privilege:11,w",
        "notSub",
      ]);
    },
    request() {
      if (this.isUnReview) {
        return this.searchData;
      }

      return {
        ...this.searchData,
        ...this.dateRange,
      };
    },
    isUnReview() {
      return this.statusItem.value == 0;
    },
    actions() {
      return [
        {
          value: 0,
          label: this.$t("component.dropdown.review.undo"),
          active: true,
        },
        {
          value: 1,
          label: this.$t("component.dropdown.review.up"),
        },
        {
          value: 2,
          label: this.$t("component.dropdown.review.down"),
        },
        {
          value: 3,
          label: this.$t("component.dropdown.review.veto"),
        },
      ];
    },
  },
  created() {
    this.statusItem = this.actions[0];

    api.getColumns().then((response) => {
      this.reviewedColumns = response.data.reviewedColumns;
      this.reviewColumns = response.data.reviewColumns;
      this.downColumns = response.data.downColumns;
      this.columns = this.reviewColumns;
      this.$refs.table.init(this.request);
    });
  },
  methods: {
    handleChangeStatus(item) {
      this.statusItem = item;
    },
    handleSearch() {
      // let searchData = {...this.searchData}

      // if (!this.isUnReview)  {
      //   searchData = {...searchData, ...this.dateRange}
      // }

      this.$refs.table.search(this.request);
    },
    handleLoaded() {
      let value = this.statusItem.value;
      if (value === 2) {
        this.columns = this.downColumns;
      } else if (value !== 0) {
        this.columns = this.reviewedColumns;
      } else {
        this.columns = this.reviewColumns;
      }
    },
    review(row, action) {
      this.reviewItem = { ...row, action };
      this.showReviewDialog = true;
    },
    handleReviewSuccess() {
      this.$refs.table.refresh();
    },
  },
  watch: {
    statusItem(val) {
      this.searchData.status = val.value;
      if (val.value == 0) {
        this.searchData.startDate = "";
        this.searchData.endDate = "";
      }
    },
  },
};
</script>
